import COUNTRY_ISO_CODES from "@wingspanhq/utils/dist/fixtures/country-iso-codes-list.json";

export const selectorCountryName = (alpha2Code: string) =>
  COUNTRY_ISO_CODES.find(country => country["alpha-2"] === alpha2Code)?.name;
